/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function DocumentRemoveIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "document-remove", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 3.9H10.2515L10.0757 4.07574L6.07573 8.07574L5.89999 8.25147V8.5V11.9H7.09999V9.1H10.5H11.1V8.5V5.1H17.9V11.9H19.1V4.5V3.9H18.5H10.5ZM19.1 14.1H17.9V19.9H7.09999V14.1H5.89999V20.5V21.1H6.49999H18.5H19.1V20.5V14.1ZM9.89999 7.9H7.94852L9.89999 5.94853V7.9Z", fill: "currentColor" }),
        React.createElement("path", { d: "M2 13H23", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(DocumentRemoveIcon);
export default ForwardRef;
//# sourceMappingURL=documentRemoveIcon.js.map